import React from "react";
import PropTypes from "prop-types";
import "../../index.css";
import { CardStatus, CARD_STATUS_TYPE } from "../../components/CardStatus";
import { ApiService } from "../../utils/ApiService";
import { API_URL } from "../../utils/Constants";
import { uploadStatusDateFormat } from "../../utils/Helper";
import { CircularProgress, Typography } from "@mui/material";
import {
  ADMIN_TYPE,
  STUDENT_DATA_CONSTANTS,
  API_METHOD_POST,
  API_CONTEXT_TYPE,
} from "../../config/constants";

export class ActivityStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: true,
      showStatus: false,
      uploadStatusData: [],
    };
  }

  componentDidMount() {
    this.onGetStatus();
  }

  onGetStatus = async () => {
    try {
      const roleData = localStorage.getItem("role");
      let merchantIdGlobal = localStorage.getItem("globalMerchantId");

      if (roleData == ADMIN_TYPE.SCHOOL_ADMIN) {
        merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");
      }

      const url = API_URL.UPLOAD_TRACKER + "?schoolId=" + merchantIdGlobal;
      const resp = await ApiService.postRequest(url);
      if (resp.status.code === "Y" && resp.body && resp.body.length > 0) {
        const statusArray = resp.body.filter(
          (obj) =>
            obj.totalCount > 0 &&
            (obj.fileStatus === STUDENT_DATA_CONSTANTS.FILESTATUS_COMPLETED ||
              obj.fileStatus ===
                STUDENT_DATA_CONSTANTS.FILESTATUS_AUTORETIRED ||
              obj.fileStatus === STUDENT_DATA_CONSTANTS.FILESTATUS_ABORTED)
        );
        this.setState({ uploadStatusData: statusArray });
      }
      this.setState({ isFetching: false });
    } catch (err) {
      console.error("Error fetching upload status:", err);
    }
  };

  onDownload = (s3FileLocation) => {
    let authCode = localStorage.getItem("bearer");
    let fileName = s3FileLocation.split("/")[3];
    const url =
      API_URL.DOWNLOAD_FAILURE_RECORD_EXCEL_FILE + "?fileName=" + fileName;
    fetch(url, {
      method: API_METHOD_POST,
      headers: {
        Authorization: authCode,
        Accept: API_CONTEXT_TYPE,
      },
    })
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch((err) => alert(err));
  };

  renderCurrentStatus() {
    const statusObj = this.props.currentStatus;
    if (!statusObj) return null;
    if (
      statusObj.completionStatus === STUDENT_DATA_CONSTANTS.FILESTATUS_PROGRESS
    ) {
      return (
        <CardStatus
          type={CARD_STATUS_TYPE.PROGRESS}
          title={statusObj.message}
          desc={uploadStatusDateFormat(statusObj.updateTimestamp)}
        />
      );
    }
    if (
      statusObj.completionStatus ===
        STUDENT_DATA_CONSTANTS.FILESTATUS_COMPLETED &&
      !statusObj.showDonwloadButton
    ) {
      return (
        <CardStatus
          type={CARD_STATUS_TYPE.SUCCESS}
          title={statusObj.message}
          desc={"now"}
        />
      );
    }
    if (
      statusObj.completionStatus ===
        STUDENT_DATA_CONSTANTS.FILESTATUS_COMPLETED &&
      statusObj.showDonwloadButton
    ) {
      return (
        <CardStatus
          type={CARD_STATUS_TYPE.ERROR}
          title={statusObj.message}
          desc="now"
        />
      );
    }
    if (
      statusObj.completionStatus === STUDENT_DATA_CONSTANTS.FILESTATUS_ABORTED
    ) {
      return (
        <CardStatus
          type={CARD_STATUS_TYPE.ERROR}
          title={statusObj.message}
          desc=" "
        />
      );
    }
    if (
      statusObj.completionStatus === STUDENT_DATA_CONSTANTS.FILESTATUS_RETRY
    ) {
      return (
        <CardStatus
          type={CARD_STATUS_TYPE.PROGRESS}
          title={statusObj.message}
          desc={statusObj.percentageCompleted}
        />
      );
    }
    if (
      statusObj.completionStatus === STUDENT_DATA_CONSTANTS.FILESTATUS_PREPARE
    ) {
      return (
        <CardStatus
          type={CARD_STATUS_TYPE.PROGRESS}
          title={STUDENT_DATA_CONSTANTS.PREPARING_STATUS}
          desc={""}
        />
      );
    }
  }

  renderStatusCard() {
    if (
      this.state.isFetching ||
      this.props.newLogin ||
      this.props.isNewLoginDelete
    )
      return null;
    let timeStr = "";
    return this.state.uploadStatusData.map((obj, idx) => {
      if (obj.fileStatus === STUDENT_DATA_CONSTANTS.FILESTATUS_ABORTED) {
        const newTime = obj.updateTimestamp.split("T")[0];
        const showDiv = timeStr != newTime;
        timeStr = newTime;
        const description =
          obj.description || `Aborted - ${obj.origionalFilename}`;
        return (
          <div key={`Aborted-${obj.description}-${idx}`}>
            {showDiv ? <Typography variant="h4">{timeStr}</Typography> : null}
            <CardStatus
              type={CARD_STATUS_TYPE.ERROR}
              title={description}
              desc={uploadStatusDateFormat(obj.updateTimestamp)}
            />
          </div>
        );
      } else if (obj.failureCount === 0) {
        const newTime = obj.updateTimestamp.split("T")[0];
        const showDiv = timeStr != newTime;
        timeStr = newTime;
        const description =
          obj.description ||
          `Succesfully Processed ${obj.successCount} records from ${obj.origionalFilename}`;
        return (
          <div key={`Succeeded-${obj.description}-${idx}`}>
            {showDiv ? <Typography variant="h4">{timeStr}</Typography> : null}
            <CardStatus
              type={CARD_STATUS_TYPE.SUCCESS}
              title={description}
              desc={uploadStatusDateFormat(obj.updateTimestamp)}
            />
          </div>
        );
      } else {
        const newTime = obj.updateTimestamp.split("T")[0];
        const showDiv = timeStr != newTime;
        timeStr = newTime;
        const description =
          obj.description ||
          `Processed ${obj.successCount} records successfully with ${obj.failureCount} records failure from ${obj.origionalFilename}`;
        return (
          <div key={`Processed-${obj.description}-${idx}`}>
            {showDiv ? <Typography variant="h4">{timeStr}</Typography> : null}
            <CardStatus
              type={CARD_STATUS_TYPE.PROGRESS}
              title={description}
              desc={uploadStatusDateFormat(obj.updateTimestamp)}
              onClick={() => this.onDownload(obj.s3Location)}
            />
          </div>
        );
      }
    });
  }

  renderNoRecord() {
    if (
      this.state.isFetching ||
      this.props.newLogin ||
      this.props.isNewLoginDelete
    ) {
      return (
        <div className="acivity-inacive">
          <CircularProgress size={24} thickness={5} />
        </div>
      );
    }
    const statusObj = this.props.currentStatus;
    if (statusObj || this.state.uploadStatusData.length > 0) return null;
    return (
      <div className="acivity-inacive">
        <Typography variant="h5" component="span">
          {STUDENT_DATA_CONSTANTS.ACTIVITY_NO_RECORD}
        </Typography>
      </div>
    );
  }

  render() {
    return (
      <div className="activity-status-container">
        <div className="d-flex flex-column mb-3 gap-4 w-100">
          <Typography variant="h5" component="span">
            {STUDENT_DATA_CONSTANTS.ACTIVITY_STATUS_HEADER}
          </Typography>

          {this.renderCurrentStatus()}
          {this.renderStatusCard()}
          {this.renderNoRecord()}
        </div>
      </div>
    );
  }
}

ActivityStatus.propTypes = {
  currentStatus: PropTypes.shape({
    completionStatus: PropTypes.string,
    percentageCompleted: PropTypes.number,
    message: PropTypes.string,
    showDonwloadButton: PropTypes.bool,
    s3FileLocation: PropTypes.string,
  }),
  abortAction: PropTypes.func,
  newLogin: PropTypes.bool,
  isNewLoginDelete: PropTypes.bool,
};
